import {getToken, removeToken, setToken} from '@/common/auth'
import router, {resetRouter} from '@/router'
// import { getUserLogin } from '@/api/modules/login'
// import $api from '@/api/index.ts'
import {Message} from 'element-ui'
import { getUserLogin, getUserInfo } from '@/api/modules/login'
import { getDoctorHosp } from '@/api/modules/report'
import {localRoutes, page404} from '@/router'
import {fetchClodop} from "@/common/LodopFuncs";

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: {},
  roles: [],
  errData: '',
  userInfo: {},
  organization: [],
  hospInf:[],
  recipeNum:0
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_ERRDATA: (state, data) => {
    state.errData = data
  },
  SET_ORG: (state, org) => {
    state.organization = org
  },
  SET_HOSP: (state, hosp) => {
    state.hospInf = hosp
  },
  SET_RecipeNum: (state,recipeNum) => {
    state.recipeNum = recipeNum
  }
}

const actions = {
  // user login
  login: function ({commit}, userInfo) {
    return new Promise((resolve, reject) => {
      getUserLogin(userInfo).then(res => {
        if (res && res.data){
          const {data} = res
          commit('SET_TOKEN', data)
          setToken(data)
          resolve()
        } else {
          reject()
        }
      }).catch(() => {
        reject()
      })
    })
  },
  // get user info
  getInfo({commit}) {
    return new Promise((resolve, reject) => {
      getUserInfo().then(res => {
        if (res.data) {
          commit('SET_ROLES', res.data.account)
          commit('SET_USERINFO', res.data)
          fetchClodop() //加载打印插件
          resolve(res)
        } else {
          Message.error('账号被冻结，请联系管理员')
          router.push('/')
          reject()
        }
      }).catch(() => {
        reject()
      })
    })
  },
  // 获取机构,县乡村信息
  organization({commit}) {
    return new Promise(() => {
      commit('SET_ORG', JSON.parse(JSON.stringify([])))

      // getCountDoctorHosp().then(res => {
      //   let arr = []
      //   let num = 0
      //   if (res.data){
      //     arr.push({idCount: 0 ,region:'', name:'全部',level: '' })
      //     res.data.forEach(val=>{
      //       val.idCount = val.idCount || 0
      //       val.region = val.level
      //       val.name = val.level
      //       num += val.idCount
      //       arr.push(val)
      //     })
      //     arr[0].idCount = num
      //   }
      //   commit('SET_ORG', JSON.parse(JSON.stringify(arr)))
      //   // resolve()
      // }).catch(error => {
      //   Message.error(error.msg || '网络连接失败, 请稍后重试')
      //   // alert(error)
      //   // reject(error)
      // })
      getDoctorHosp().then(res => {
        commit('SET_HOSP', res.data)
        // resolve()
      }).catch(error => {
        Message.error(error.msg || '网络连接失败, 请稍后重试')

        // alert(error)
        // reject(error)
      })
    })
  },
  // user logout
  logout({commit, dispatch}) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resetRouter()
      dispatch('tagsView/delAllViews', null, {root: true})
      window.location.reload()
      resolve()
    })
  },
  errData({commit}, dispatch) {
    return new Promise((resolve) => {
      commit('SET_ERRDATA', dispatch)
      resolve()
    })
  },
  // remove token
  resetToken({commit}) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  changeRoles({commit, dispatch}, role) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const {roles} = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, {root: true})

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)
      router.addRoutes(localRoutes)
      router.addRoutes(page404)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, {root: true})

      resolve()
    })
  },
  setRecipeNum({commit}, num) {
    commit('SET_RecipeNum', num)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
